export interface Topic {
  first_click: string,
  last_click: string,
  num_clicks: number,
  objectId: number,
  title: string,
}

export interface DataSet {
  primaryAction: any,
  results: Topic[]
}

export interface TagCloudEntry {
  count: number,
  topic: Topic,
  value: string,
}

const toTagCloudItem = (topic: Topic): TagCloudEntry => {
  const entry: TagCloudEntry = {
    count: topic.num_clicks,
    topic,
    value: topic.title,
  }
  return entry
}

export const toTagCloud = (topics: Topic[]): TagCloudEntry[] => {
  return topics.map((t: Topic) => toTagCloudItem(t))
}

export const emptyState: DataSet = {
  primaryAction: {},
  results: []
}

export const noTag: TagCloudEntry = {
  count: 0,
  topic: null,
  value: '',
}
